// extracted by mini-css-extract-plugin
export default {"meinian-image-box-pagination":"index_meinian-image-box-pagination__4kzQr"};